module.exports = __webpack_public_path__ + "static/media/TransferColor.2d401786.svg";